
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Pricing from '@/components/Pricing';

const Priser = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-28 pb-10 md:pt-36 md:pb-12 connection-lines">
        <div className="container mx-auto px-4 sm:px-6 text-center mb-6">
          <div className="inline-block rounded-full bg-yellow-300/20 px-4 py-1.5 mb-4">
            <span className="text-sm font-montserrat font-bold text-darkgray">Transparent prissättning</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-montserrat font-bold text-center mb-3 text-darkgray">
            Prisplaner för alla anbudsgivare
          </h1>
          <p className="text-xl md:text-2xl font-opensans max-w-3xl mx-auto text-darkgray/80 mb-2">
            Spara upp till 70% av din anbudstid
          </p>
          <p className="text-lg md:text-xl font-opensans max-w-2xl mx-auto text-darkgray/70">
            Vi erbjuder tre prisplaner anpassade för företag i alla storlekar som deltar i offentliga upphandlingar. Betala endast för det du behöver.
          </p>
        </div>
      </section>
      
      {/* Pricing Section */}
      <Pricing />
      
      <Footer />
    </div>
  );
};

export default Priser;
